import React from 'react';
import { ErrorBoundary } from '../ErrorBoundary';

interface CrashSafeWrapperProps {
  children: React.ReactNode;
  level?: 'page' | 'section' | 'component';
  name?: string;
}

export const CrashSafeWrapper: React.FC<CrashSafeWrapperProps> = ({
  children,
  level = 'component',
  name = 'Component'
}) => {
  const handleError = (error: Error) => {
    console.error(`[${level.toUpperCase()}] ${name} crashed:`, error);
  };

  return (
    <ErrorBoundary onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};
